import ConversationPanel from "@/common/components/wavvest-planning/conversation-panel";
import VisualizationPanel from "@/common/components/wavvest-planning/visualization-panel";
import Sidebar from "@/common/components/wavvest-planning/conversation-panel/sidebar";
import { SessionHistoryDrawer } from "@/common/components/wavvest-planning/conversation-panel";
import { useEffect, useState } from "react";
import canvasWebSocket from "@/services/websocket-service";
import { resetCanvas } from "@/store/features/canvas/canvasSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "@/store/hooks";

import "./index.scss";

const Canvas = () => {
  const dispatch = useDispatch();
  const [isHistoryDrawerOpen, setIsHistoryDrawerOpen] = useState(false);
  const hasVisualization = useAppSelector((state) =>
    Boolean(state.canvas.visualization.sourceCode),
  );

  useEffect(() => {
    const initWebSocket = async () => {
      await canvasWebSocket.connect();
    };
    void initWebSocket();
  }, []);

  const handleSidebarHistoryClick = () => {
    setIsHistoryDrawerOpen(true);
  };

  const handleSidebarEditClick = () => {
    console.log("Edit mode activated - canvas main display");
  };

  const handleResetCanvas = async () => {
    if (canvasWebSocket.getConnectionStatus()) {
      canvasWebSocket.disconnect();
      await canvasWebSocket.connect();
    }
    dispatch(resetCanvas());
  };

  return (
    <div
      className={`canvas-container ${hasVisualization ? "has-visualization" : "chat-only"}`}
    >
      <Sidebar
        onHistoryClick={handleSidebarHistoryClick}
        onEditClick={handleSidebarEditClick}
        onNewCanvasClick={handleResetCanvas}
        isHistoryDrawerOpen={isHistoryDrawerOpen}
      />
      <div className="canvas-left-container">
        <div className="canvas-chat-shell">
          <ConversationPanel />
        </div>
      </div>
      {hasVisualization && (
        <div className="canvas-right-container">
          <VisualizationPanel />
        </div>
      )}
      <SessionHistoryDrawer
        open={isHistoryDrawerOpen}
        onClose={() => setIsHistoryDrawerOpen(false)}
      />
    </div>
  );
};

export default Canvas;
